// app/javascript/controllers/invoice_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "totalBeforeTax", "tax", "totalAfterTax", "vat", "discount", "discountType", "discountRate", "discountAmount", "totalAfterDiscount"]

  connect() {
    console.log("InvoiceFormController#connect")

    this.calculateItemTotals()
    this.calculateTotal()
    this.setupEventListeners()
  }

  setItemTotal(item, total) {
    const totalElement = item.querySelector("[data-invoice-form-target='itemTotal']");
    totalElement.textContent = this.formatCurrency(total)
  }

  setupEventListeners() {
    this.itemsTarget.addEventListener("input", (event) => {
      const item = event.target.closest("[data-nested-form-target='entry']")
      this.setItemTotal(item, this.calculateItemTotal(item));
      this.calculateTotal()
    });

    this.vatTarget.addEventListener("input", (event) => {
      this.calculateTotal()
    });
  }

  calculateItemTotal(itemElement) {
    const price = parseFloat(itemElement.querySelector("[name$='[unit_price]']").value) || 0
    const quantity = parseInt(itemElement.querySelector("[name$='[quantity]']").value) || 0
    return price * quantity;
  }

  calculateItemTotals() {
    this.itemsTarget.querySelectorAll("[data-nested-form-target='entry']").forEach(item => {
      const total = this.calculateItemTotal(item);
      this.setItemTotal(item, total);
    })
  }

  calculateDiscount() {
    const discountType = this.discountTypeTarget.value;
    const discountRate = parseFloat(this.discountRateTarget.value);
    const discountAmount = parseFloat(this.discountAmountTarget.value);
    const totalBeforeTax = this.totalBeforeTax();

    this.discountTarget.textContent = 0;

    let discount = 0;

    if (discountType === "percentage") {
      discount = discountRate / 100 * totalBeforeTax;
    } else if (discountType === "amount") {
      discount = discountAmount;
    }

    this.discountTarget.textContent = this.formatCurrency(discount);
    return isNaN(discount) ? 0 : discount;
  }

  totalBeforeTax() {
    const items = this.element.querySelectorAll("[data-nested-form-target='entry']")

    const totalBeforeTax = Array.from(items).reduce((total, item) => {
      return total +  this.calculateItemTotal(item)
    }, 0)
    return totalBeforeTax;
  }

  totalAfterDiscount() { return this.totalBeforeTax() - this.calculateDiscount() }

  calculateTotal() {
    const totalBeforeTax = this.totalBeforeTax();
    const discount = this.calculateDiscount();
    const totalAfterDiscount = this.totalAfterDiscount();

    this.totalBeforeTaxTarget.textContent = this.formatCurrency(totalBeforeTax);
    this.totalAfterDiscountTarget.textContent = this.formatCurrency(totalAfterDiscount);

    // let vat;
    //
    // if (this.vatTarget.tagName.toLowerCase() === "input") {
    //   vat = parseFloat(this.vatTarget.value);
    // } else if (this.vatTarget.tagName.toLowerCase() === "div") {
    //   vat = parseFloat(this.vatTarget.textContent);
    // }
    //
    // if (isNaN(vat)) { vat = 0}

    const vat = 0.15;

    const discountTax = discount * vat;
    const taxAmount = totalBeforeTax * vat - discountTax;

    this.taxTarget.textContent = this.formatCurrency(taxAmount);


    const totalAfterTax = totalAfterDiscount + taxAmount;
    this.totalAfterTaxTarget.textContent = this.formatCurrency(totalAfterTax);
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      // style: 'currency',
      // currency:
    }).format(amount)
  }

  taxTypeChange(event) {
    const taxTypeId = event.target.value;

    if (taxTypeId) {
      fetch(`/tax_types/${taxTypeId}`)
        .then(response => response.json())
        .then(data => {
          this.vatTarget.value = data.tax_rate;
          this.calculateTotal()
        })
    }

  }
}
